import * as React from "react";
import { MediaQuery, Modal, Card } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { Footer } from "../../modules/Footer/modules/Footer/Footer.js";
import { PickupStoresContainer } from "../../StepShipping/modules/ShippingMethods/containers/StepShipping/modules/ShippingMethods/containers/PickupStoresContainer.js";
/* empty css                  */
import { ShippingMethodsListContainer } from "../../StepShipping/modules/ShippingMethods/containers/StepShipping/modules/ShippingMethods/containers/ShippingMethodsListContainer.js";
import { PickupPointsContainer } from "../../StepShipping/modules/ShippingMethods/containers/StepShipping/modules/ShippingMethods/containers/PickupPointsContainer.js";
import { EditableAddressesSummary } from "../EditableSummaries/StepOverview/EditableSummaries/EditableAddressesSummary.js";
import { EditableContactDetailsSummary } from "../EditableSummaries/StepOverview/EditableSummaries/EditableContactDetailsSummary.js";
import { EditableInvoiceSummary } from "../EditableSummaries/StepOverview/EditableSummaries/EditableInvoiceSummary.js";
import { EditableCompanySummary } from "../EditableSummaries/StepOverview/EditableSummaries/EditableCompanySummary.js";
import { ServiceStore } from "../../modules/ServiceStore/layout/modules/ServiceStore/layout/ServiceStore.js";
import { EditableLoyaltyPointsSummary } from "../EditableSummaries/StepOverview/EditableSummaries/EditableLoyaltyPointsSummary.js";
import { StepNames } from "../../models/models/shared.js";
import { getShippingMethodInfo } from "../../utils/utils/get-shipping-method-info.js";
import { useCheckoutSettings } from "../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const StepOverview = ({
  isPickupStore,
  isPickupPoint,
  labels,
  onEdit,
  onNextClick,
  onPrevClick,
  selectedStore,
  shippingMethodsAsides,
  serviceStore,
  selectedPickupPoint,
  shippingMethod,
  cartComponent,
  shippingMethodList,
  onStoreSelect,
  onPickupPointSelect,
  handleOnShippingMethodSelected,
  onShippingModalClose
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { getLabel } = useIntl();
  const currentBreakpoint = MediaQuery.useBreakpoint();
  const { allowAlternativeShippingState = false } = useFeatureToggles();
  const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
  const shippingMethodInfo = getShippingMethodInfo(
    labels.summary,
    shippingMethod?.method,
    shippingMethodsAsides
  );
  const { features } = useCheckoutSettings();
  const hasEditButton = !allowAlternativeShippingState;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Modal,
    {
      title: labels.completed.shipmentDetailsDelivery,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true,
      isOpen: isModalOpen
    },
    /* @__PURE__ */ React.createElement("div", { className: "checkout-step--overview__delivery-methods" }, shippingMethodList ? /* @__PURE__ */ React.createElement(
      ShippingMethodsListContainer,
      {
        onChange: () => setIsModalOpen(false),
        asides: shippingMethodsAsides,
        shippingMethodList,
        selectedShippingMethod: shippingMethod,
        handleOnShippingMethodSelected
      }
    ) : null)
  ), /* @__PURE__ */ React.createElement("div", { className: "checkout-step checkout-step--overview" }, /* @__PURE__ */ React.createElement("div", { className: "checkout-step checkout-step--overview card--colapse-borders" }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2" }, labels.yourDetails), /* @__PURE__ */ React.createElement(Card, { className: "checkout-card__reset-bottom-border-radius" }, /* @__PURE__ */ React.createElement(Card.Content, null, onEdit && !allowAlternativeShippingState && /* @__PURE__ */ React.createElement(Card.Actions, null, /* @__PURE__ */ React.createElement(
    Card.Button,
    {
      onClick: () => setIsModalOpen(true),
      children: getLabel("common.actions.edit")
    }
  )), /* @__PURE__ */ React.createElement(Card.Text, { variant: "body-head", className: "checkout-step--overview__caption" }, labels.completed.shipmentDetailsDelivery), /* @__PURE__ */ React.createElement(Card.Text, { color: "text-secondary", variant: "caption" }, shippingMethodInfo.label, " ", shippingMethodInfo.aside && shippingMethodInfo.aside, isPickupStore && !selectedStore && /* @__PURE__ */ React.createElement(
    PickupStoresContainer,
    {
      hasWarningMessageOnly: true,
      selectedStore,
      onStoreSelect,
      hasEditButton,
      onShippingModalClose
    }
  ), isPickupPoint && !selectedPickupPoint && /* @__PURE__ */ React.createElement(
    PickupPointsContainer,
    {
      hasWarningMessageOnly: true,
      onPickupPointSelect,
      selectedPickupPoint,
      hasEditButton,
      onShippingModalClose
    }
  )))), isPickupStore && selectedStore && /* @__PURE__ */ React.createElement(
    PickupStoresContainer,
    {
      isTitleHidden: true,
      selectedStore,
      onStoreSelect,
      hasEditButton
    }
  ), isPickupPoint && selectedPickupPoint && /* @__PURE__ */ React.createElement(
    PickupPointsContainer,
    {
      isTitleHidden: true,
      onPickupPointSelect,
      selectedPickupPoint
    }
  ), /* @__PURE__ */ React.createElement(EditableAddressesSummary, { labels }), /* @__PURE__ */ React.createElement(EditableContactDetailsSummary, { labels }), /* @__PURE__ */ React.createElement(EditableInvoiceSummary, { labels }), /* @__PURE__ */ React.createElement(EditableCompanySummary, { labels }), features?.isServiceStoreEnabled && serviceStore && !isPickupStore && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ServiceStore, { className: "checkout-card__reset-border-radius" })), /* @__PURE__ */ React.createElement(EditableLoyaltyPointsSummary, null), isMobile && /* @__PURE__ */ React.createElement("div", { className: "checkout-step--overview__cart" }, cartComponent), /* @__PURE__ */ React.createElement(Footer, { stepName: StepNames.Overview, onPrevStep: onPrevClick, onNextStep: onNextClick }))));
};
export {
  StepOverview
};
//# sourceMappingURL=StepOverview.js.map
